import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Link } from 'core/routing';
import { withNamespaces } from 'react-i18next';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';
import { CollectionCardImage } from 'apps/collection/views/cardImage';

import {
  Card,
  InfoWrapper,
  Title,
  Count,
  Description,
  CardFooter,
  CardFooterList,
  CardFooterItem,
  CardFooterButton,
} from 'legacyComponents/cards/styles';

@withNamespaces()
@observer
export class CollectionCard extends React.Component {
  render() {
    const { cardObject, cardNo, cardColumns, t } = this.props;

    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='collection' />;
    }

    const {
      name,
      projectsCount,
      content,
      description,
      slug,
      spacePath,
      images,
    } = cardObject;
    let spaceType = 'profile';
    if (spacePath[0] === '+') {
      spaceType = 'initiative';
    }
    const route = `${spaceType}.collection`;
    const { followersCount } = content;

    return (
      <Card noMargin={noMargin}>
        <Link
          name={route}
          params={{ [spaceType]: spacePath, slug }}
          content={content}
        >
          <CollectionCardImage images={images} />
        </Link>
        <InfoWrapper>
          <Link
            name={route}
            params={{ [spaceType]: spacePath, slug }}
            content={content}
          >
            <Title>
              {name} <Count>({projectsCount})</Count>
            </Title>
          </Link>
          <Description>{description}</Description>
        </InfoWrapper>
        <CardFooter>
          <Tooltip />
          <CardFooterList>
            <CardFooterItem>
              <Icon
                name='user'
                title='Followers'
                data-tip={t('{{followersCount}} followers', {
                  followersCount,
                })}
              />
              {followersCount}
            </CardFooterItem>
          </CardFooterList>
          <Link
            name={route}
            params={{ [spaceType]: spacePath, slug }}
            content={content}
          >
            <CardFooterButton icon='arrow_right' appearance='plain' />
          </Link>
        </CardFooter>
      </Card>
    );
  }
}

CollectionCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
  t: PropTypes.func,
};
